import React from 'react';
import { useCalendarActionsData } from '../../../../services/calendarActionsProvider';
import {
  registrationEvents,
  useRegistrationControllers,
} from '../../../../services/acceptanceRegistration';

const OpenSetupIntervalForRegistration = ({ children }) => {
  const { notify } = useRegistrationControllers();

  const { interval, targetDate } = useCalendarActionsData();

  const handleClick = () => {
    notify(registrationEvents.SELECT_REGISTRATION_INTERVAL, {
      interval,
      targetDate,
    });
  };

  return <div onClick={handleClick}>{children}</div>;
};

export default OpenSetupIntervalForRegistration;
